const tone = (done, total) => {
  if (!total || !done) return "bg-white text-zinc-500 border-zinc-300";
  if (done >= total) return "bg-emerald-50 text-emerald-800 border-emerald-300";
  return "bg-amber-50 text-amber-800 border-amber-300";
};

const sessionsOf = (c) => {
  const days = parseInt(c.days, 10) || 1;
  if (days >= 3) return 3;
  return days >= 2 || (c.course_type === "inicial" && c.time_start_day2) ? 2 : 1;
};

const Chip = ({ label, done, total, testId }) => (
  <span
    className={`inline-flex items-center h-9 px-3 rounded-md border text-xs font-bold tabular-nums tracking-wide ${tone(done, total)}`}
    data-testid={testId}
  >
    {label} {done}/{total}
  </span>
);

// Firmas de cada sesión y exámenes hechos; se refresca solo cada pocos segundos.
export const CourseProgressChips = ({ course, progress }) => {
  const p = progress || { s1: 0, s2: 0, s3: 0, exams: 0, total: 0 };
  const sessions = sessionsOf(course);
  return (
    <>
      <Chip label="1ª" done={p.s1} total={p.total} testId={`course-progress-s1-${course.id}`} />
      {sessions >= 2 && (
        <Chip label="2ª" done={p.s2} total={p.total} testId={`course-progress-s2-${course.id}`} />
      )}
      {sessions >= 3 && (
        <Chip label="3ª" done={p.s3} total={p.total} testId={`course-progress-s3-${course.id}`} />
      )}
      {course.course_type !== "ppaa" && (
        <Chip label="Exámenes" done={p.exams} total={p.total} testId={`course-progress-exams-${course.id}`} />
      )}
    </>
  );
};
